export default __webpack_public_path__ + "static/spine/owly.atlas";